import { render } from "./manFromEarth.vue?vue&type=template&id=1f3dc41e&scoped=true"
import script from "./manFromEarth.vue?vue&type=script&lang=js"
export * from "./manFromEarth.vue?vue&type=script&lang=js"

import "./manFromEarth.vue?vue&type=style&index=0&id=1f3dc41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3dc41e"]])

export default __exports__